<template>
  <div>
    <div class="com-page-title">
      <div class="inner">{{ $route.meta.title }}</div>
    </div>
    <template v-if="payload.pid == 0">
      <!-- 随喜金额 -->
      <Casual :payload="payload" v-if="payload.price == 0"/>
      <!-- 供灯祈福 -->
      <Pray :payload="payload" v-else/>
    </template>
    <!-- 纪念日 -->
    <Anniversary :payload="payload" v-else-if="payload.pid == 2"/>
    <!-- 功德林 -->
    <Tree :payload="payload" v-else-if="payload.pid == 3"/>
    <!-- 日常供灯 -->
    <DailyLight :payload="payload" v-else-if="payload.pid == 4"/>
  </div>
</template>

<script>
  import Casual from '@/components/fawu/FuTianCasual'
  import Anniversary from '@/components/fawu/FuTianAnniversary'
  import DailyLight from '@/components/fawu/FuTianDailyLight'
  import Pray from '@/components/fawu/FuTianPray'
  import Tree from '@/components/fawu/FuTianTree'
  export default {
    data () {
      return {
        payload: {}
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      // 详情
      getData () {
        this.$faWuApi.fuTian.getDetail({
          id: this.$route.query.id
        }).then(res => {
          if (res.success) {
            this.payload = res.data
          }
        })
      }
        
    },
    components: {
      Casual,
      Anniversary,
      Pray,
      Tree,
      DailyLight
    }
  }
</script>